// @ts-nocheck
/* eslint-disable */
import SceneFeature from "../feature";

export default class SceneMarker extends SceneFeature {
	/**
	 * Vytvoreni obecneho markeru.
	 *
	 * @param  {SceneCoords} coords Souradnice
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords?, id?, options?) {
		super(scene, itemId);

		this._coords = coords;
		this._id = id || Math.random();
		this._isDraggable = false;
		this._dragState = null;
		this._ss = [];
		this._options = {};

		if (options && options.m3dData) {
			this.updateM3dData(options.m3dData);
			delete options.m3dData;
		}

		for (let p in options) { this._options[p] = options[p]; }
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		this._scene.removeListeners(this._ss);

		super.destroy();
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarker",
			type: "marker"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.coords = this._coords;
		rd.id = this._id;
		rd.options = this._options;
		rd.isDraggable = this._isDraggable;
		rd.dragState = this._dragState;
		rd.decMarkerHover = this._decMarkerHover;

		return rd;
	}

	/**
	 * Nastaveni novych souradnic.
	 *
	 * @param {SceneCoords} coords Nove souradnice
	 */
	setCoords(coords) {
		this._coords = coords;

		this._onChange(this._scene.featureEvent("markerSetCoords", true, true), arguments);
	}

	/**
	 * Marker se stane presunovatelnym.
	 */
	decorateDraggable() {
		this._isDraggable = true;

		this._ss.push(this._scene.addListener("marker-drag-move", this._updateCoords, this, this));
		this._ss.push(this._scene.addListener("marker-drag-stop", this._updateCoords, this, this));

		this._onChange(this._scene.featureEvent("markerDecorateDraggable", true, true), arguments);
	}

	/**
	 * Funkce, ktera se zpristupni po dekoraci draggable.
	 *
	 * @param {Boolean} state Novy stav
	 */
	setDrag(state) {
		if (!this._isDraggable) return;

		this._dragState = state;

		this._onChange(this._scene.featureEvent("markerSetDrag", true, true), arguments);
	}

	/**
	 * Ziskani souradnic.
	 *
	 * @return {SceneCoords}
	 */
	getCoords() {
		return this._coords;
	}

	/**
	 * Ziskani kotvy znacky.
	 *
	 * @return {Object} klice left, top
	 */
	getAnchor() {
		return this._options.anchor;
	}

	/**
	 * Ziskani popisku znacky.
	 *
	 * @return {String}
	 */
	getTitle() {
		return this._options.title;
	}

	/**
	 * Ziskani velikost znacky.
	 *
	 * @return {Array[Number, Number]} Velikos [sirka, vyska]
	 */
	getSize() {
		return this._options.size;
	}

	/**
	 * Ziskani ID znacky.
	 *
	 * @return {Number}
	 */
	getId() {
		return this._id;
	}

	getKey() {
		return this._key;
	}

	/**
	 * Zobrazeni karty.
	 */
	showCard() {
		this._onChange(this._scene.featureEvent("markerWMShowCard", true, true), arguments);
	}

	/**
	 * Privatni metoda pro update dat - souradnice.
	 * Pri presunu znacky.
	 *
	 * @param {Object} e Event
	 * @private
	 */
	_updateCoords(e) {
		this._coords = e.data.coords;
	}

	/**
	 * Vrati vertikalni anchor vizitky markeru pro dany typ
	 *
	 * @param  {String} typeName nazev typu markeru
	 */
	getCardAnchor() {
		return this._onChange(this._scene.featureEvent("markerGetCardAnchor", true, true), arguments);
	}

	/**
	 * Zmena typu markeru.
	 *
	 * @param  {String} typeName nazev typu markeru
	 */
	setType(type) {
		this._onChange(this._scene.featureEvent("markerSetType", true, true), arguments);
	}
}
